import { render, staticRenderFns } from "./BarButton.vue?vue&type=template&id=6e0a3062&scoped=true"
import script from "./BarButton.vue?vue&type=script&lang=ts"
export * from "./BarButton.vue?vue&type=script&lang=ts"
import style0 from "./BarButton.vue?vue&type=style&index=0&id=6e0a3062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0a3062",
  null
  
)

export default component.exports